/**
 * Util to set the cookie
 * @param key - Cookie identifier
 * @param value - Cookie content
 */
const setCookie = (key: string, value: string, pathname?: string) => {
  document.cookie = `${key}=${value}; path=/`
}

/* Delete all the cookies */
function deleteAllCookies() {
  let cookies = document.cookie.split(';')

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i]
    let eqPos = cookie.indexOf('=')
    let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
  }
}

function deleteCookie(key: string) {
  document.cookie = key + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
}

const setMapTokenCookie = (value: string, time?: number) => {
  var expTime = new Date()
  expTime.setTime(expTime.getTime() + 30 * 60 * 1000) // for 30 mins
  if (time) {
    expTime = new Date(time)
  }
  document.cookie =
    `mapboxToken=${value}; expires=` + expTime.toUTCString() + '; path=/'
}

const getCookie = (key: string) => {
  let name = key + '='
  let decodedCookie = decodeURIComponent(document.cookie)
  let ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

function overrideCookie(key: string, value: string) {
  const cookies = document.cookie.split(";")
  
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim()

    if (cookie.startsWith(key + "=")) {
      setCookie(key, value)
      return
    }
  }

  setCookie(key, value);
}

export { setCookie, deleteAllCookies, setMapTokenCookie, getCookie, overrideCookie, deleteCookie }
